import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17fb93ef")

_pushScopeId("data-v-17fb93ef")
const _hoisted_1 = { class: "container providers-container" }
const _hoisted_2 = { class: "default-page-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "footer-space" }, null, -1)
const _hoisted_4 = { class: "product-edit-container" }
const _hoisted_5 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_6 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_7 = {
  type: "button",
  class: "order-modify-button-wrapper dark-circle-button"
}
const _hoisted_8 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_9 = {
  type: "button",
  class: "order-modify-button-wrapper btn-blue"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-20 text-white" }, null, -1)
const _hoisted_11 = { class: "my-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProviderDetailsComponent = _resolveComponent("ProviderDetailsComponent")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.provider.name), 1),
    _createVNode(_component_ProviderDetailsComponent, {
      modelValue: _ctx.provider,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.provider = $event))
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: { name: 'providers' } }, {
            default: _withId(() => [
              _createVNode("button", _hoisted_7, _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: { name: 'provider-edit', params: { id: _ctx.provider.id } },
            type: "submit"
          }, {
            default: _withId(() => [
              _createVNode("button", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('button.edit')), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createVNode("button", {
        class: "arrow-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
        type: "button"
      }, [
        _hoisted_12
      ])
    ])
  ]))
})